import { isAdminAuthority, isManagementAuthority } from './managementInsights'

const commonCommands = [
  { key: 'dashboard', title: 'ダッシュボード', subtitle: '今日の打刻・アクション・月次状況', route: '/dashboard', icon: 'cil-speedometer', keywords: 'home ホーム' },
  { key: 'roster', title: '勤務表', subtitle: '日々の勤務実績を入力', route: '/report/roster', icon: 'cil-calendar-check', keywords: '勤怠 タイムシート' },
  { key: 'monthly-report', title: '業務報告', subtitle: '月次の業務内容を報告', route: '/report/monthlyreport', icon: 'cil-description', keywords: '月報' },
  { key: 'expense', title: '経費精算', subtitle: '業務経費を登録・申請', route: '/payoff/expense', icon: 'cil-wallet', keywords: '精算 領収書' },
  { key: 'commute', title: '通勤費精算', subtitle: '通勤経路・交通費を登録', route: '/payoff/travelCost', icon: 'cil-bus-alt', keywords: '交通費 定期' },
  { key: 'leave', title: '休暇申請', subtitle: '有休・代休・特休を申請', route: '/paidandsubstitutes/list', icon: 'cil-sun', keywords: '有給 代休 特休' },
  { key: 'leave-planner', title: '有休取得プランナー', subtitle: '残数・取得目標・次回付与を確認', route: '/insights/paid-leave', icon: 'cil-calendar', keywords: '有給 5日 付与 残数' },
  { key: 'submission-list', title: '承認申請一覧', subtitle: '自分の提出状況を確認', route: '/submission_approval/report_list', icon: 'cil-inbox', keywords: '提出 申請' },
  { key: 'approval-list', title: '承認待ち一覧', subtitle: '自分に届いた申請を確認', route: '/submission_approval/submission_management', icon: 'cil-check-circle', keywords: '承認 差戻し' }
]

const managementCommands = [
  { key: 'workforce-heatmap', title: '人員×プロジェクト稼働', subtitle: '日別の所属・勤務時間をヒートマップ表示', route: '/admin/insights/workforce', icon: 'cil-grid', keywords: '人員 稼働 アサイン ヒートマップ' },
  { key: 'monthly-total', title: '月次集計', subtitle: 'スタッフの月次勤務集計', route: '/admin/total/list', icon: 'cil-list-rich', keywords: '勤務時間 集計' },
  { key: 'roster-admin', title: '勤務表一覧', subtitle: '全スタッフの勤務表を確認', route: '/admin/roster/list', icon: 'cil-list-rich', keywords: '勤怠 管理' },
  { key: 'users', title: 'ユーザ管理', subtitle: 'スタッフ情報を検索・更新', route: '/users/list', icon: 'cil-people', keywords: '社員 メンバー' },
  { key: 'projects', title: 'プロジェクト管理', subtitle: 'プロジェクト・所属を管理', route: '/project/list', icon: 'cil-layers', keywords: '案件 PJ' },
  { key: 'clients', title: 'クライアント管理', subtitle: '取引先情報を管理', route: '/client/list', icon: 'cil-building', keywords: '会社 顧客 取引先' }
]

const adminCommands = [
  { key: 'project-summary', title: 'プロジェクト集計', subtitle: '売上・原価・稼働を月次集計', route: '/admin/total/list_project', icon: 'cil-chart-pie', keywords: '粗利 採算' },
  { key: 'project-rate', title: 'プロジェクト単価設定', subtitle: '請求単価・原価単価を設定', route: '/admin/project-rate', icon: 'cil-money', keywords: '単価 原価 請求' },
  { key: 'sales', title: '売上管理・請求書発行', subtitle: '売上登録と請求書出力', route: '/admin/sales/salesManagement', icon: 'cil-layers', keywords: '請求 売上 PDF' },
  { key: 'profit-forecast', title: 'プロジェクト収益予測', subtitle: '売上・原価・粗利の着地を予測', route: '/admin/insights/project-profit', icon: 'cil-chart-pie', keywords: '利益 粗利 採算 予算' },
  { key: 'cash-flow', title: '入金・請求予測', subtitle: '支払期日別の入金見込みを確認', route: '/admin/insights/cash-flow', icon: 'cil-money', keywords: 'キャッシュフロー 請求 入金 支払期日' }
]

export function commandPaletteItems (authority) {
  const items = [...commonCommands]
  if (isManagementAuthority(authority)) items.push(...managementCommands)
  if (isAdminAuthority(authority)) items.push(...adminCommands)
  return items
}

export function filterCommandPaletteItems (items, query) {
  const normalized = String(query || '').trim().toLowerCase()
  if (!normalized) return items.slice(0, 12)
  return items
    .map(item => {
      const title = String(item.title || '').toLowerCase()
      const target = `${item.title || ''} ${item.subtitle || ''} ${item.keywords || ''}`.toLowerCase()
      let score = 9
      if (title === normalized) score = 0
      else if (title.startsWith(normalized)) score = 1
      else if (target.includes(normalized)) score = 3
      return { ...item, score }
    })
    .filter(item => item.score < 9)
    .sort((left, right) => left.score - right.score || left.title.localeCompare(right.title, 'ja'))
    .slice(0, 12)
}
